"use client"

import { useSession } from "../context/SessionContext"
import { useCallback, useRef } from "react"

interface UseTransferActionsProps {
  session: any
  setReturnControlToAi: (value: boolean) => void
  checkIfUserHasHistoryAndUpdate: (userId: number) => Promise<void>
}

export const useTransferActions = ({
  session,
  setReturnControlToAi,
  checkIfUserHasHistoryAndUpdate,
}: UseTransferActionsProps) => {
  const { refreshTokenIfNeeded } = useSession()
  const suppressNextSelectRef = useRef(false)

  const markTransferAsSeen = useCallback(
    async (userId: string | number, transferId: number) => {
      const numericUserId: any = userId

      try {
        await refreshTokenIfNeeded()
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/communications/markTransferAsSeen/${transferId}`,
          {
            method: "PATCH",
            headers: {
              Authorization: `${session!.token_type} ${session!.access_token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ is_open: true }),
          },
        )

        if (!response.ok) {
          throw new Error("Failed to mark transfer as seen")
        }

        setReturnControlToAi(true)
        
      } catch (error) {
        console.error("Error marking transfer as seen:", error)
      }
    },
    [session, refreshTokenIfNeeded, setReturnControlToAi],
  )

  return {
    markTransferAsSeen,
    suppressNextSelectRef,
  }
}
